import {
  Checkbox,
  IComboBox,
  IComboBoxOption,
  Panel,
  PanelType,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PlantillaCrearCheckList } from "./PlantillaCrearCheckList";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import { useComboModelos } from "../../../hooks/combosHooks/useComboModelos";
import {
  IPlantillaCrearCheckList,
  InitialPlantillaCrearCheckList,
} from "../../../Interfaces/ListaVerificacion/Plantilla/IPlantillaListaverficacion";
import { useComboGrupoVerificacion } from "../../../hooks/combosHooks/useComboGrupoVerificacion";
import { useComboPropiedadesVerificacion } from "../../../hooks/combosHooks/useComboPropiedadesVerificacion";
import { IPropiedadesPorGrupo } from "../../../Interfaces/ListaVerificacion/PropiedadesVerificacion/IPropiedadesVerificacion";
import { PlantillaPreViewGrupo } from "./PlantillaPreViewGrupo";
import {
  IObjetoDetalle,
  IPostCrearPlantillaVerificacion,
  InitialIPostCrearPlantillaVerificacion,
} from "../../../Interfaces/IPlantillaVerificacion";

interface IPanelCrearCheckList {
  isOpen: boolean;
  onDismiss: () => void;
}

export const PanelCrearCheckList = (props: IPanelCrearCheckList) => {
  const [dataPlantillaListaVerificacion, setDataPlantillaListaVerificacion] =
    useState<IPlantillaCrearCheckList>(InitialPlantillaCrearCheckList);
  const [listDataGrupo, setListDataGrupo] = useState<IPropiedadesPorGrupo[]>(
    []
  );
  const [requestPostCrear, setRequestPostCrear] =
    useState<IPostCrearPlantillaVerificacion>(
      InitialIPostCrearPlantillaVerificacion
    );
  const [objetoRequestDetalle, setObjetoRequestDetalle] =
    useState<IObjetoDetalle>(null!);
  const [objetoGrupo, setObjetoGrupo] = useState<IPropiedadesPorGrupo>(null!);
  const [numeroGrupo, setNumeroGrupo] = useState<number>(1);

  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
  } = useComboModelos();

  const {
    dataComboGrupoVeri,
    onClickComboGrupoVeri,
    _onkeyUpSearchGrupoVeri,
    comboBoxRefGrupoVeri,
  } = useComboGrupoVerificacion();
  const {
    postComboPropiedadesVerificacion,
    dataComboPropiedadesVerificacion,
    limpiarCheckBox,
  } = useComboPropiedadesVerificacion();

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="Add"
          subTextHeader="Crear CheckList"
          textHeader="Gestión de CheckList"
        />
      </>
    ),
    []
  );

  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    
      setDataPlantillaListaVerificacion({
        ...dataPlantillaListaVerificacion,
        nombrePlantilla: newValue,
      });
      setRequestPostCrear({ ...requestPostCrear, nombrePlantilla: newValue ? newValue:"" });
    
  };

  const onChangeCombo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    nombre?: string
  ) => {
    if (event !== undefined) {
      if (option) {
        switch (nombre) {
          case "modeloEquipo":
            setDataPlantillaListaVerificacion({
              ...dataPlantillaListaVerificacion,
              modeloEquipo: option.text,
            });
            setRequestPostCrear({
              ...requestPostCrear,
              equipoModeloId: option.key.toString(),
            });

            break;
          case "GrupoVerificacion":
            postComboPropiedadesVerificacion(option.key.toString());

            setDataPlantillaListaVerificacion({
              ...dataPlantillaListaVerificacion,
              grupoVerificacion: option.text,
            });
            setObjetoGrupo({ grupoName: option.text, propiedades: [] });
            setObjetoRequestDetalle({
              grupo: numeroGrupo,
              propiedadVerificacionId: [],
            });
            break;
          default:
            break;
        }
      }
    }
  };
  const _onChangeCheckBox = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean
  ) => {
    let { id, name } = ev?.target as HTMLInputElement;

    let arrayAux = objetoGrupo.propiedades;
    let arrayPostAux = objetoRequestDetalle.propiedadVerificacionId;
    if (checked) {
      arrayAux.push({ key: id, text: name });
      arrayPostAux.push(id);
    } else {
      arrayAux = arrayAux.filter((item) => item.key !== id);
      arrayPostAux = arrayPostAux.filter((item) => item !== id);
    }
    setObjetoRequestDetalle({
      ...objetoRequestDetalle,
      propiedadVerificacionId: arrayPostAux,
    });
    setObjetoGrupo({ ...objetoGrupo, propiedades: arrayAux });
  };
  useEffect(() => {
    if (!props.isOpen) {
      setDataPlantillaListaVerificacion(InitialPlantillaCrearCheckList);
      setListDataGrupo([]);
      setRequestPostCrear({...InitialIPostCrearPlantillaVerificacion,detalle:[]});
      setObjetoRequestDetalle(null!);
      setObjetoGrupo(null!);
      setNumeroGrupo(1);
      limpiarCheckBox()
    }
  }, [props.isOpen]);
  return (
    <>
      <Panel
        type={PanelType.large}
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        isFooterAtBottom
        onRenderHeader={onRenderHeader}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "70%",
              flexDirection: "row",
              alignItems: "center",
              margin: "10px",
              borderRight: "1px solid black",
            }}
          >
           {/*  <pre>{JSON.stringify(requestPostCrear, null, 2)}</pre> */}
            <div className="ms-Grid" dir="ltr">
              <div
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                  <TextField
                    label="Nombre de la plantilla:"
                    underlined
                    required
                    placeholder="Escribir aquí"
                    onChange={onChangeTextField}
                  />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                  <ComboBoxIDS
                    title="Modelos de Equipos:"
                    componentRef={comboBoxRefModelos}
                    KeyUp={_onkeyUpSearchDispositivo}
                    onClick={onClickComboModelos}
                    options={dataComboModelos}
                    onChange={(e, o) => onChangeCombo(e, o, "modeloEquipo")}
                  />
                </div>
              </div>
              <br />
              <div
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                  <ComboBoxIDS
                    title="Grupo de verificación:"
                    componentRef={comboBoxRefGrupoVeri}
                    KeyUp={_onkeyUpSearchGrupoVeri}
                    onClick={onClickComboGrupoVeri}
                    options={dataComboGrupoVeri}
                    onChange={(e, o) =>
                      onChangeCombo(e, o, "GrupoVerificacion")
                    }
                  />
                </div>
              </div>
              <br />
              <div
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "start",
                }}
              >
                <div
                  className="ms-Grid-col ms-sm12 ms-md6 ms-lg6"
                  style={{ maxHeight: "700px", overflow: "scroll" }}
                >
                  {dataComboPropiedadesVerificacion.map((item) => (
                    <div style={{ marginTop: "10px" }}>
                      <Checkbox
                        key={item.key}
                        label={`${item.text}`}
                        name={`${item.text}`}
                        id={`${item.key}`}
                        onChange={_onChangeCheckBox}
                      />
                    </div>
                  ))}
                </div>
                <div
                  className="ms-Grid-col ms-sm12 ms-md6 ms-lg6"
                  style={{ margin: "10px" }}
                >
                  <PlantillaPreViewGrupo data={objetoGrupo} indice={1} />
                </div>
              </div>
              <div
                className="ms-Grid-row"
                style={{
                  marginTop: "50px",
                }}
              >
                <div
                  className="ms-Grid-col ms-sm12 ms-md6 ms-lg12"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end", // Cambiado de 'justifyItems' a 'justifyContent'
                    alignItems: "end",
                  }}
                >
                  <PrimaryButton
                    iconProps={{ iconName: "AddFriend" }}
                    text="Agregar Grupo"
                    onClick={() => {
                      setListDataGrupo((prev) => {
                        return [...prev, objetoGrupo];
                      });
                      let aux = requestPostCrear.detalle;
                      aux.push(objetoRequestDetalle);
                      setRequestPostCrear({
                        ...requestPostCrear,
                        detalle: aux,
                      });

                      setNumeroGrupo(numeroGrupo + 1);
                      setObjetoGrupo(null!);
                      limpiarCheckBox();
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              width: "30%",
              margin: "10px",
            }}
          >
            <PlantillaCrearCheckList
              onDismissPanel={props.onDismiss}
              datos={dataPlantillaListaVerificacion}
              dataGrupos={listDataGrupo}
              postCrearCheckList={requestPostCrear}
            />
          </div>
        </div>
      </Panel>
    </>
  );
};
